import chapterDuesProfile from './chapter-dues-profile/chapter-dues-profile.js';
import memberBreakdown from './member-breakdown/member-breakdown.js';
import memberRenewal from './member-renewal/member-renewal.js';
import rebatesReimbursements from './rebates-reimbursements/rebates-reimbursements.js';
import leaderList from './leader-list/leader-list.js';
import loadingSpinner from './loading-spinner/loading-spinner.js';
import httpError from './http-error/http-error.js';
import renewalMessage from './renewal-message/renewal-message.js';
import uploadCPE from './upload-cpe/upload-cpe.js';

let ComponentsModule = angular.module('clp-components', [
    chapterDuesProfile,
    memberBreakdown,
    memberRenewal,
    rebatesReimbursements,
    leaderList,
    loadingSpinner,
    httpError,
    renewalMessage,
    uploadCPE
])
    .name;

export default ComponentsModule;



// WEBPACK FOOTER //
// ./src/app/angular/clp-dashboard.components.js